import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'wt-ui';
import GroupView from '../../components/GroupView';
import AssetClassHeader from '../../components/AssetClassHeader';

const reducer = (state, action) => {
  switch (action.type) {
    case 'setOrder': {
      let newOrder = 'desc';
      if (state.order === 'desc') {
        newOrder = 'asc';
      } else if (state.order === 'asc') {
        newOrder = '';
      }
      return { ...state, order: newOrder };
    }
    case 'setSelected':
      return { ...state, selected: action.value };
    default:
      throw new Error();
  }
};

const AssetClass = ({ data, nColumns, blink }) => {
  const [state, dispatch] = useReducer(reducer, {
    order: 'default',
    selected: Object.keys(data.groups).map((x) => Number(x)),
  });

  const filteredAndOrderedData = () => {
    const aux = [].concat(
      ...data.groups.filter((_group, index) => state.selected.indexOf(index) > -1).map((group) => group.underlyingList),
    );
    switch (state.order) {
      case 'asc':
        aux.sort((a, b) => a.chg - b.chg);
        break;
      case 'desc':
        aux.sort((a, b) => b.chg - a.chg);
        break;
      default:
        if (aux.length > 0 && aux[0].order) {
          aux.sort((a, b) => a.order - b.order);
        }
        break;
    }
    return aux;
  };

  return (
    <Box background="transparent" data-section-name={data.name}>
      <AssetClassHeader
        name={data.name}
        order={state.order}
        groups={data.groups.map((g) => g.name)}
        selected={state.selected}
        dispatch={dispatch}
      />
      <Box background="transparent">
        <GroupView
          data={{
            name: '',
            underlyingList: filteredAndOrderedData(),
          }}
          blink={blink}
          nColumns={nColumns}
        />
      </Box>
    </Box>
  );
};
AssetClass.propTypes = {
  data: PropTypes.shape({}).isRequired,
  blink: PropTypes.arrayOf(PropTypes.string).isRequired,
  nColumns: PropTypes.number.isRequired,
};

export default AssetClass;
